<!--
  ~ Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
  ~ This software is released under MIT license.
  ~ The full license information can be found in LICENSE in the root directory of this project.
  -->

<div class="alerts-pager-control">
  <div class="alerts-page-down">
    <button class="alerts-pager-button" type="button" (click)="pageDown()" [attr.aria-label]="previousAlertAriaLabel">
      <cds-icon shape="angle" direction="left"></cds-icon>
    </button>
  </div>
  <div class="alerts-pager-text">{{this.multiAlertService.current+1}} / {{this.multiAlertService.count}}</div>
  <div class="alerts-page-up">
    <button class="alerts-pager-button" type="button" (click)="pageUp()" [attr.aria-label]="nextAlertAriaLabel">
      <cds-icon shape="angle" direction="right"></cds-icon>
    </button>
  </div>
</div>
